<div *ngFor="let option of possibleValues" class="field-radiobutton mb-1">
    <p-radiobutton [attr.id]="option.value" name="searchValue" [value]="option.value" [(ngModel)]="searchValue"
        (onClick)="handleOptionsClick($event)" [disabled]="disableField"></p-radiobutton>
    <label [for]="option.value">{{option.name}}</label>
</div>